import data from '../data';

describe('data', () => {
  test('it should have the expected properties', () => {
    expect(data).toHaveProperty('columns');
  });
});
